import { SortType } from '@gp/enums/common';

// import type { Action, Reducer, Effect } from 'umi';
import type { Action, Reducer } from 'umi';
import type { SortBy } from 'tea-component/lib/table/addons';
import type { IPayload, ISearchPayloadPageStore } from '@gp/types/global';
import type { IProjectGRActionItemsFilterVO, IProjectGRActionItemProjectVO } from '@gp/types/grActionItems';

export interface ILockerData {
  lock: boolean;
  filter: IProjectGRActionItemsFilterVO;
  sort: SortBy<IProjectGRActionItemProjectVO>[];
  search: ISearchPayloadPageStore;
}

type IUpdateLockerDataAction = Action<'updateLockerData'> & IPayload<any>;
type IClearLockerDataAction = Action<'clearLockerData'> & IPayload<unknown>;

interface ILockerModel {
  namespace: string;
  state: ILockerData;
  reducers: {
    updateLockerData: Reducer<ILockerData, IUpdateLockerDataAction>;
    clearLockerData: Reducer<ILockerData, IClearLockerDataAction>;
  };
  effects: {};
}

export const LOCKER_MODEL_NAMESPACE = 'dbg-model-pipeline-gr-action-items-locker';

export const DEFAULT_FILTER: IProjectGRActionItemsFilterVO = {
  dueDate: {
    dateType: 'date',
    startDate: '',
    endDate: '',
  },
  pteam: [],
  business_owner: [],
  studio: [],
  gate_review: [],
  owner: [],
  status: [],
  stage: [],
};

export const DEFAULT_SORT: SortBy<IProjectGRActionItemProjectVO>[] = [
  { by: 'project', order: SortType.Desc },
  { by: 'due_date', order: SortType.Asc },
];

export const DEFAULT_SEARCH: ISearchPayloadPageStore = {
  search_type: 'exact',
  search_keyword: '',
  search: [],
  search_list: [],
};

export const DEFAULT_LOCKER_DATA: ILockerData = {
  lock: false,
  filter: DEFAULT_FILTER,
  sort: DEFAULT_SORT,
  search: DEFAULT_SEARCH,
};

const LockerModel: ILockerModel = {
  namespace: LOCKER_MODEL_NAMESPACE,
  state: DEFAULT_LOCKER_DATA,
  reducers: {
    updateLockerData(state, action) {
      return { ...state, ...action?.payload, lock: true };
    },
    clearLockerData(state) {
      return { ...state, ...DEFAULT_LOCKER_DATA, lock: false };
    },
  },
  effects: {},
};

export default LockerModel;
